var exports = {
  "step": "x7f9a0e16--343660--step",
  "primary": "x7f9a0e16--343660--primary",
  "secondary": "x7f9a0e16--343660--secondary",
};

module.exports = exports;
